import "./nocReport.css";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getNocReport } from "../../api/searchApi";
import Spinner from "../layouts/spinner/spinner";
import PageHeader from "../layouts/pageHeader/pageHeader";

const NocReport = () => {
    let { crfId, crfName } = useParams();
    const [isSearching, setIsSearching] = useState(false);
    const [searchResults, setSearchResults] = useState(null);

    useEffect(() => {
        const doSearch = async () => {
            setIsSearching(true);
            let results = await getNocReport(crfId);
            //console.log(results);
            setSearchResults(results);
            setIsSearching(false);
        };

        doSearch();
    }, [crfId]);

    return (
        <div className="noc-report">
            <PageHeader>
                <strong>NINDS CDE Notice of Copyright<br/>
                {crfName}</strong>
            </PageHeader>
            {isSearching && <Spinner />}
            {searchResults &&
                <table className="noc-report-table">
                    <tbody>
                        {searchResults.map(noc => {
                            const sectionText = { __html: noc.sectionText };

                            return (
                                <tr key={noc.nocDetailsId}>
                                    <td className="item-value">{noc.itemValue}</td>
                                    <td dangerouslySetInnerHTML={sectionText}></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            }
        </div>
    );
};

export default NocReport;